export default "__VITE_ASSET__Cs9VY_Kj__"